<template>
  <div>
    <div class="row">
      <div class="col-12">
        <p class="title-report">
          <strong>Relatório de METAS</strong>
        </p>
      </div>

      <div class="col-12 general-header" v-if="items.length">
        <div class="row justify-content-between">
          <div class="col">
            <div class="card">
              <p style="font-size: 18px;">NPS</p>

              <h5>
                <b-spinner v-if="isLoadingNps" type="grow" small></b-spinner>
                <span v-else>{{ completedSteps }}</span>
                <!-- <div class="custom-badge badge-warning float-right">
                  &uarr; 10
                </div> -->
              </h5>
            </div>
          </div>

          <div class="col">
            <div class="card">
              <p style="font-size: 18px;">Meta NPS</p>

              <h5>
                {{ totalMetaNps }}
                <!-- <div class="custom-badge badge-success float-right">
                  &uarr; 10
                </div> -->
              </h5>
            </div>
          </div>

          <div class="col">
            <div class="card">
              <p style="font-size: 18px;">Amostra total</p>

              <h5>
                {{ totalAnswers }}
                <!-- <div class="custom-badge badge-success float-right">
                  &uarr; 10
                </div> -->
              </h5>
            </div>
          </div>

          <div class="col">
            <div class="card">
              <p style="font-size: 18px;">Amostra meta</p>

              <h5>
                {{ totalAnswersMeta }}
                <!-- <div class="custom-badge badge-success float-right">
                  &uarr; 10
                </div> -->
              </h5>
            </div>
          </div>

          <div class="col">
            <div class="card">
              <p style="font-size: 18px;">Atingimento de meta</p>

              <h5>
                {{ goalTarteg }}%
                <!-- <div class="custom-badge badge-success float-right">
                  &uarr; 10
                </div> -->
              </h5>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-9">
        <div v-if="items.length">
          <b-alert variant="secondary" show>
            <div class="row">
              <div class="col-3 text-center">
                <h4>NPS</h4>

                <h4 class="text-center">
                  <b-spinner v-if="isLoadingNps" type="grow" small></b-spinner>
                  <b-badge :style="getPercentColor(completedSteps)" v-else>{{
                    completedSteps
                  }}</b-badge>
                </h4>
              </div>

              <div class="col-3 text-center">
                <h5>Respostas</h5>
                <h4>{{ totalAnswers }}</h4>
              </div>

              <div class="col-3 text-center">
                <h5>Meta Resposta</h5>
                <h4>{{ totalAnswersMeta }}</h4>
              </div>

              <div class="col-3 text-left">
                <p style="padding: 0; margin-bottom: 2px;">
                  Promotores:
                  <b-badge
                    small
                    class="pull-right"
                    :style="getPercentColor(100)"
                  >
                    {{ promoters }}</b-badge
                  >
                </p>
                <p style="padding: 0; margin-bottom: 2px;">
                  Neutros:
                  <b-badge
                    small
                    class="pull-right"
                    :style="getPercentColor(51)"
                    >{{ passives }}</b-badge
                  >
                </p>
                <p style="padding: 0; margin-bottom: 2px;">
                  Detratores:
                  <b-badge
                    small
                    class="pull-right"
                    :style="getPercentColor(1)"
                    >{{ detractors }}</b-badge
                  >
                </p>
              </div>
            </div>
          </b-alert>
        </div>
      </div> -->
    </div>

    <div class="col-12 mt-3" style="padding-left: 0; padding-right: 0;">
      <b-button
        style="
          width: 90px;
          border-radius: 0;
          border: none;
          background: transparent;
        "
        @click="viewType = 'ih1'"
        :style="{
          borderBottom: viewType === 'ih1' ? '2px solid #4DE594' : 'none',
          color: viewType === 'ih1' ? '#4DE594' : '',
        }"
        >IH1</b-button
      >

      <b-button
        style="
          width: 90px;
          border-radius: 0;
          border: none;
          background: transparent;
        "
        @click="viewType = 'ih2'"
        :style="{
          borderBottom: viewType === 'ih2' ? '2px solid #4DE594' : 'none',
          color: viewType === 'ih2' ? '#4DE594' : '',
        }"
        >IH2</b-button
      >
      <div
        style="
          width: 100%;
          height: 1px;
          border-bottom: solid 2px #e8e8e8;
          margin-top: -2px;
        "
      ></div>

      <!-- <b-form-radio-group
        id="type-radio-group"
        name="radio"
        buttons
        v-model="viewType"
      >
        <b-form-radio
          :button-variant="
            viewType === 'ih1' ? 'outline-success' : 'outline-light'
          "
          name="ih1"
          value="ih1"
          >IH1</b-form-radio
        >
        <b-form-radio
          :button-variant="
            viewType === 'ih2' ? 'outline-success' : 'outline-light'
          "
          name="ih2"
          value="ih2"
          >IH2</b-form-radio
        >
      </b-form-radio-group> -->
    </div>
    <div v-if="loader" class="row mb-4">
      <div class="col-12 text-center">
        <b-spinner
          variant="primary"
          type="grow"
          :label="`${this.$t('reports.loadingLabel')}...`"
        ></b-spinner>
      </div>
    </div>
    <div v-else-if="this.items.length > 0">
      <div class="row mt-4">
        <div class="col-12">
          <b-table
            id="table-indicators"
            striped
            :fields="fields"
            :items="items"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :per-page="perPage"
            :current-page="currentPage"
            :busy="loading"
          >
            <template v-slot:cell(filial)="row">
              <div style="width: 200px;">{{ row.item.filial }}</div>
            </template>
            <template v-slot:cell(metaPercent)="row">
              <h4>
                <b-badge :style="getPercentColor(row.item.metaPercent)">
                  {{ row.item.metaPercent }}%
                </b-badge>
              </h4>
            </template>
            <template v-slot:cell(promotersPercent)="row">
              {{ row.item.promotersPercent }}%
            </template>
            <template v-slot:cell(neutralPercent)="row">
              {{ row.item.neutralPercent }}%
            </template>
            <template v-slot:cell(detractorsPercent)="row">
              {{ row.item.detractorsPercent }}%
            </template>
            <template v-slot:cell(nps)="row">
              <h4>
                <b-badge :style="getPercentColor(row.item.nps)">
                  {{ Number(row.item.nps) }}
                </b-badge>
              </h4>
            </template>
            <!-- <template v-slot:cell(metaPercentNps)="row">
              <b-badge :style="getPercentColor(row.item.metaPercentNps)"
                >{{ row.item.metaPercentNps }}%</b-badge
              >
            </template> -->
          </b-table>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            aria-controls="table-indicators"
          ></b-pagination>
        </div>
        <div class="col-6 mt-2 text-right">
          <a
            @click="exportToXLS"
            :title="`${this.$t('reports.exportXlsLabel')}`"
          >
            <span class="xls">
              <i class="fas fa-file-download"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
    <div v-else-if="!firstDisplayed" class="row mt-4">
      <div class="col-12 text-center">
        <p>
          <font-awesome-icon
            :icon="['fas', 'folder-open']"
            style="margin-right: 20px; font-size: 35px;"
          />
        </p>
        <h5>
          {{ this.$t('reports.indicators.noDatalabel') }}
        </h5>
        <p>
          {{ this.$t('reports.indicators.noAnswerLabel') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import swal from 'sweetalert';
import { mapActions, mapState } from 'vuex';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import npsBar from '@/components/molecules/nps-bar';
import loader from '@/components/atoms/loader';
import api from '../../../../../services/api';

export default {
  name: 'Metas',

  components: {
    RadialProgressBar,
    animatedNumber,
    npsBar,
    loader,
  },

  data: () => ({
    loading: false,
    loadingDownload: false,
    sortBy: null,
    sortDesc: null,
    userAuth: null,
    search: null,
    loader: false,
    fields: [],
    items: [],
    keepItems: [],
    total: 0,
    currentPage: 1,
    perPage: 20,
    indicatorSelected: null,
    indicatorLabels: [],
    firstDisplayed: true,
    chartPromoters: '',
    chartPassives: '',
    chartDetrators: '',
    promoters: '',
    passives: '',
    detrators: '',
    detractors: '',
    metricLabel: '',
    totalSteps: 100,
    viewType: 'ih1',
    completedSteps: null,
    colorBalance: '#fff',
    totalAnswers: null,
    totalAnswersMeta: null,
    isLoadingNps: false,
    goalTarteg: null,
    totalMetaNps: null,
  }),

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.changeLabel();
    this.fields = [
      {
        key: 'filial',
        label: 'Filial',
        sortable: true,
        class: 'text-left',
      },
      {
        key: 'nps',
        label: this.metricLabel,
        sortable: true,
      },
      {
        key: 'promotersPercent',
        label: `% ${this.chartPromoters}`,
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'neutralPercent',
        label: `% ${this.chartPassives}`,
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'detractorsPercent',
        label: `% ${this.chartDetrators}`,
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'metaPercent',
        label: '%Amostra',
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'meta',
        label: 'Meta',
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'answers',
        label: this.$t('reports.answersLabel'),
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'answerMeta',
        label: 'Meta Resposta',
        sortable: true,
        class: 'text-center',
      },
      // {
      //   key: 'metaPercentNps',
      //   label: '%Meta',
      //   sortable: true,
      //   class: 'text-center',
      // },
    ];
  },

  async mounted() {
    await this.getIndicators();
  },

  watch: {
    actionGroupData: async function watchActionGroupData() {
      await this.getIndicators();
    },

    myActionId: async function watchMyActionId() {
      await this.getIndicators();
    },

    myActionsIds: async function watchMyActionsIds() {
      await this.getIndicators();
    },

    myIh1: async function watchMyIh1() {
      await this.getIndicators();
    },

    myHierarchies1: async function watchMyHierarchies1() {
      await this.getIndicators();
    },

    myIh2: async function watchMyIh2() {
      await this.getIndicators();
    },

    myHierarchies2: async function watchMyHierarchies2() {
      await this.getIndicators();
    },

    items: function watchItems() {
      this.total = this.items.length;
    },

    calendarDates: async function watchDates() {
      await this.getIndicators();
    },

    myMetric: async function watchMyMetric() {
      this.changeLabel();
      await this.getIndicators();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.getIndicators();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.getIndicators();
    },

    viewType: async function watchViewType() {
      await this.getIndicators();
    },
  },

  computed: {
    ...mapState('dashboard', ['nps', 'percentilNps']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  methods: {
    ...mapActions('dashboard', ['getMetricValue']),
    ...mapActions('calendar', ['setDefaultDates']),

    loadNps() {
      this.isLoadingNps = true;
      this.getMetricValue({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric ? this.myMetric : null,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.setColorNps(this.nps);
        if (this.myMetric.indexOf('nps') !== -1) {
          this.completedSteps = this.nps.toFixed(1);
        } else if (this.myMetric.indexOf('ces') !== -1) {
          this.completedSteps = this.nps.toFixed(2);
        } else if (this.myMetric.indexOf('csat') !== -1) {
          this.completedSteps = this.nps.toFixed(1);
        } else if (this.myMetric.indexOf('stars') !== -1) {
          this.completedSteps = this.nps.toFixed(1);
        } else if (this.myMetric.indexOf('like-dislike') !== -1) {
          this.completedSteps = this.nps.toFixed(1);
        }

        this.promoters = this.percentilNps.promoters;
        this.passives = this.percentilNps.passive;
        this.detractors = this.percentilNps.detractors;
        this.isLoadingNps = false;
      });
    },

    getPercentColor(value) {
      if (!value) {
        return 'background-color: transparent';
      }
      value = Number(value);
      if (value <= 50) {
        return 'background-color: #E1513D; color: #ffffff; width: 72px;';
      } else if (value <= 80 && value > 50) {
        return 'background-color: #FCBE30; color: #ffffff; width: 72px;';
      } else if (value <= 100 && value > 80) {
        return 'background-color: #37C888; color: #ffffff; width: 72px;';
      } else if (value > 100) {
        return 'background-color: #5299F2; color: #ffffff; width: 72px;';
      }
      return '';
    },
    returnMetric() {
      if (this.myMetric.indexOf('nps') !== -1) {
        return 'NPS';
      } else if (this.myMetric.indexOf('ces') !== -1) {
        return 'CES';
      } else if (this.myMetric.indexOf('csat') !== -1) {
        return 'CSAT';
      } else if (this.myMetric.indexOf('5-stars') !== -1) {
        return '5-Stars';
      } else if (this.myMetric.indexOf('like-dislike') !== -1) {
        return 'Like/Dislike';
      }
      return '';
    },
    async getIndicators() {
      this.loader = true;
      this.firstDisplayed = false;
      this.loadNps();

      const response = await api.get(
        `${process.env.API_ROOT}/reports/metas/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
            startDate: this.calendarDates.start
              ? this.calendarDates.start
              : null,
            endDate: this.calendarDates.end ? this.calendarDates.end : null,
            metric: this.myMetric ? this.myMetric : null,
            groupId: this.actionGroupData._id,
            type: this.viewType,
          },
        },
      );

      this.items = response.data;

      this.totalAnswers = this.items.reduce((a, b) => a + (b.answers || 0), 0);

      const totalMeta = this.items.reduce((a, b) => a + (b.meta || 0), 0);

      const totalItems = this.items.filter((item) => item.meta && item.meta > 0)
        .length;

      this.totalMetaNps =
        totalMeta && totalItems ? (totalMeta / totalItems).toFixed(0) : '--';

      this.totalAnswersMeta = this.items.reduce(
        (a, b) => a + (b.answerMeta || 0),
        0,
      );

      this.goalTarteg =
        this.totalAnswers && this.totalAnswersMeta
          ? ((this.totalAnswers / this.totalAnswersMeta) * 100).toFixed(1)
          : '--';

      this.loader = false;
    },

    async downloadAnswers(item) {
      this.loadingDownload = true;

      this.apiServerlessDownloads = process.env.API_SERVERLESS_DOWNLOADS;

      try {
        await api.get(
          `${this.apiServerlessDownloads}/answers/download/${this.userAuth.companyId}/xlsx`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              startDate: this.calendarDates.start,
              endDate: this.calendarDates.end,
              actionId:
                  this.myActionsIds.length === 0
                    ? null
                    : JSON.stringify(this.myActionsIds),
                ih1:
                  this.myHierarchies1.length === 0
                    ? null
                    : JSON.stringify(this.myHierarchies1),
                ih2:
                  this.myHierarchies2.length === 0
                    ? null
                    : JSON.stringify(this.myHierarchies2),
              groupId: this.actionGroupData._id,
              indicator: item.indicator,
              indicatorValue: item.description,
              indicatorRange: this.indicatorData.range,
              npsByIndicatorReportFilter: this.indicatorName,
              npsByIndicatorReportFilterValue: this.indicatorData.value,
            },
          },
        );

        swal({
          title: this.$t('reports.sucessLabel'),
          text: this.$t('reports.downloadMsg'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: `${this.$t('reports.errorLabel')}...`,
          text: error.response.data.message,
          icon: 'error',
        });
      }

      this.loadingDownload = false;
    },

    npsColor(number) {
      let color;

      if (this.myMetric.indexOf('nps') !== -1) {
        if (number === 0) color = '#d62027';
        if (number < 10) color = '#ff0000';
        if (number >= 10 && number < 20) color = '#f05223';
        if (number >= 20 && number < 30) color = '#f36f21';
        if (number >= 30 && number < 40) color = '#faa823';
        if (number >= 40 && number < 50) color = '#ffca27';
        if (number >= 50 && number < 60) color = '#ecdb12';
        if (number >= 60 && number < 70) color = '#e8e73d';
        if (number >= 70 && number < 80) color = '#c5d92d';
        if (number >= 80 && number < 90) color = '#afd136';
        if (number >= 90 && number <= 100) color = '#4ce595';
      } else if (
        this.myMetric.indexOf('ces') !== -1 ||
        this.myMetric.indexOf('stars') !== -1 ||
        this.myMetric.indexOf('csat') !== -1
      ) {
        if (number <= 1) color = '#ff0000';
        if (number >= 1 && number < 2) color = '#f36f21';
        if (number >= 2 && number < 3) color = '#ffca27';
        if (number >= 3 && number < 4) color = '#e8e73d';
        if (number >= 4 && number < 5) color = '#afd136';
        if (number >= 5) color = '#4ce595';
      } else if (this.myMetric.indexOf('like-dislike') !== -1) {
        if (number <= 50) color = '#ff0000';
        if (number > 51) color = '#4ce595';
      }

      return color;
    },
    setColorNps(percentBalace) {
      if (this.myMetric.indexOf('nps') !== -1) {
        if (percentBalace >= 80) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 80 && percentBalace >= 70) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 70 && percentBalace >= 50) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 50 && percentBalace >= 0) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 0) {
          this.colorBalance = 'red';
        }
      } else if (this.myMetric.indexOf('ces') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace <= 1) {
          this.colorBalance = 'red';
        }
      } else if (this.myMetric.indexOf('csat') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 1) {
          this.colorBalance = 'red';
        }
      } else if (this.myMetric.indexOf('stars') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 1) {
          this.colorBalance = 'red';
        }
      } else if (this.myMetric.indexOf('like-dislike') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 1) {
          this.colorBalance = 'red';
        }
      }
    },
    formatToPrice(value) {
      if (this.myMetric === 'csat-1-5(media)') {
        return value.toFixed(1);
      } else if (
        this.myMetric.indexOf('ces') !== -1 ||
        this.myMetric.indexOf('stars') !== -1
      ) {
        return value.toFixed(2);
      }
      return value.toFixed(0);
    },

    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

    exportToXLS() {
      const header = [
        this.$t('reports.indicators.indicatorLabel'),
        this.$t('reports.indicators.descriptionLabel'),
        this.$t('reports.answersLabel'),
        this.chartPromoters,
        this.chartPassives,
        this.chartDetrators,
        this.metricLabel,
      ];

      const arr = [];

      this.items.forEach((el) => {
        arr.push({
          [this.$t('reports.indicators.indicatorLabel')]: el.indicator,
          [this.$t('reports.indicators.descriptionLabel')]: el.description,
          [this.$t('reports.answersLabel')]: el.answers,
          [this.chartPromoters]: `${el.promotersPercent}%`,
          [this.chartPassives]: `${el.neutralPercent}%`,
          [this.chartDetrators]: `${el.detractorsPercent}%`,
          [this.metricLabel]: el.nps,
        });
      });

      const wb = XLSX.utils.book_new();

      wb.SheetNames.push('indicadores');

      const ws = XLSX.utils.json_to_sheet(arr, { header });

      wb.Sheets.indicadores = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'indicadores.xlsx');
      document.body.appendChild(link);
      link.click();
    },

    changeLabel() {
      if (this.myMetric.indexOf('nps') !== -1) {
        this.chartPromoters = this.$t('reports.promoterLabel');
        this.chartPassives = this.$t('reports.neutralLabel');
        this.chartDetrators = this.$t('reports.detractorLabel');
        this.metricLabel = this.$t('reports.npsLabel');
        this.totalSteps = 100;
      } else if (this.myMetric.indexOf('ces') !== -1) {
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.metricLabel = this.$t('reports.cesLabel');
        this.totalSteps = 5;
      } else if (this.myMetric.indexOf('csat') !== -1) {
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.metricLabel = 'CSAT';
        this.totalSteps = 5;
      } else if (this.myMetric.indexOf('stars') !== -1) {
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.metricLabel = '5Stars';
        this.totalSteps = 5;
      } else if (this.myMetric.indexOf('like-dislike') !== -1) {
        this.chartPromoters = 'Like';
        this.chartDetrators = 'Dislike';
        this.metricLabel = 'Like/Dislike';
        this.totalSteps = 100;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.card {
  padding: 12px 16px 12px 16px;
  border-radius: 6px;
  border: solid 1px #e8e8e8;
  p {
    font-size: 75%;
    font-weight: 200;
    margin: 0;
    padding: 0;
  }
  h5 {
    margin: 0;
    padding: 0;
  }
}

.custom-badge {
  font-size: 70%;
  padding: 2px 10px;
  gap: 2px;
  border-radius: 9px;
  text-align: center;
  width: 55px;
  height: 20px;
}

.badge-warning {
  background: rgba(242, 232, 68, 0.3);
  color: #fcbe30;
}

.badge-success {
  background: #dbfaea;
  color: #3db374;
}

h4 {
  margin: 0;
  padding: 0;
  margin-top: -7px;
}

.badge {
  font-size: 65%;
  font-weight: normal;
}

.badge-secondary {
  padding: 6px;
}
.download-answers-icon {
  padding: 5px 15px;
  background: $primary;
  color: $white;
  border-radius: 10px;
  font-size: 15px;
  border: none;
  transition: background-color 0.2s;

  &:hover {
    cursor: pointer;
    background: #1dc86e;
  }
}

.radial-progress-inner {
  span {
    font-size: 16px !important;
  }
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;

  transition: color 0.2s;

  &:hover {
    color: #1dc86e;
  }
}

.width150 {
  width: 350px !important;
}

.font-12 {
  font-size: 12px;
}
.btn:focus,
.btn::before {
  outline: none;
  box-shadow: none;
}

.btn:focus ~ .btn::before {
  box-shadow: none !important;
}

.btn:focus,
.btn:active:focus,
.btn.active:focus,
.btn.focus,
.btn:active.focus,
.btn.active.focus {
  box-shadow: none;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/metas/index.vue